import { useTheme } from "@emotion/react";
import {
  FormControl,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { fonts } from "fonts";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { botActions } from "store/bot";

export default function ContextSizeSelector({
  ...props
}) {

  const options = [0, 1, 2, 3, 4, 5];
  const theme = useTheme();

  const dispatch = useDispatch();
  const botState = useSelector((state) => state.bot);
  const botId = botState.current;
  const bot = botState.idMap[botId];
  const contextSize = useSelector((state) => state.bot.contextSize);
  const modelsState = useSelector((state) => state.collections.models);
  const modelData = modelsState && !modelsState.loading && bot ? modelsState.idMap[bot.model] : null;
  const isImage = modelData && modelData.type.endsWith("/image");


  useEffect(() => {
    if(botState.current) { 
      dispatch(botActions.setContextSize(botState.idMap[botState.current].contextSize));
    }
  }, [botState.current]);


  if(isImage) return null;

  return (
    <FormControl
      {...props}
      sx={{
        width: "80px",
        borderRadius: 1,
      }}
    >
      <Stack alignItems="center" justifyContent="center">
        <Tooltip
          title="Number of previous messages considered when answering."
          placement="top"
        >
          <Typography
            fontSize={9}
            sx={{ color: theme.palette.text.primary }}
            textAlign="center"
            fontFamily={fonts.geist}
          >
            context size
          </Typography>
        </Tooltip>
        <Select
          size="small"
          value={contextSize}
          onChange={(event) =>
            dispatch(botActions.setContextSize(event.target.value))
          }
          sx={{
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.inputBackground.main,
            "& .MuiSelect-select": {
              backgroundColor: theme.palette.inputBackground.main,
            },
            ".MuiSelect-icon": {
              color: theme.palette.text.primary,
            },
            ".MuiInputLabel-root": {
              color: theme.palette.text.primary,
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </FormControl>
  );
}
